// WebPage.js
import { useState } from 'react';
import { Tabs, Flowbite, Carousel } from 'flowbite-react';
import { format } from 'date-fns';
import useWebPageController from '../controllers/useWebPageController';
import PortoModal from '../components/PortoModal';
import { PDFViewer } from '@react-pdf/renderer';
import BasicAtsTemplate from '../templates/BasicAtsTemplate';
import Seo from '../components/Seo';
import PDFViewerCustom from '../components/PDFViewerCustom';

const glassCard = "bg-white/20 backdrop-blur-lg border border-white/30 shadow-xl rounded-xl hover:border-white/50 transition-all duration-300";
const glassPanel = "bg-white/40 backdrop-blur-lg border border-white/50 shadow-lg rounded-xl";
const glassPanelDark = "bg-gray-900/90 backdrop-blur-lg border border-white/50 shadow-lg rounded-xl";
const textPrimary = "text-gray-800";
const textPrimaryLight = "text-gray-50";
const textSecondary = "text-gray-600";
const textSecondaryLight = "text-white";
const textAccent = "text-gray-700";

const socialIcons = {
  Email: (
    <svg aria-label="email icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"/>
    </svg>
  ),
  LinkedIn: (
    <svg aria-label="LinkedIn icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
    </svg>
  ),
  GitHub: (
    <svg aria-label="GitHub icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.156-1.11-1.464-1.11-1.464-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.089 2.91.833.091-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.65.64.699 1.028 1.592 1.028 2.683 0 3.841-2.337 4.687-4.565 4.937.359.307.678.915.678 1.846 0 1.335-.012 2.415-.012 2.741 0 .267.18.577.688.48C19.138 20.161 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
    </svg>
  ),
  Behance: (
    <svg aria-label="Behance icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.5 5.5h-6v14h6c3.04 0 5.5-2.46 5.5-5.5s-2.46-5.5-5.5-5.5zm0 9.5h-3v-8h3c2.21 0 4 1.79 4 4s-1.79 4-4 4zm12.5-5.5c0 2.485-2.02 4.5-4.5 4.5h-2v-9h2c2.48 0 4.5 2.015 4.5 4.5zM13 10.5h3v3h-3z"/>
    </svg>
  ),
  Instagram: (
    <svg aria-label="Instagram icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 011.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772 4.915 4.915 0 01-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 100 10 5 5 0 000-10zm6.5.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM12 9a3 3 0 110 6 3 3 0 010-6z"/>
    </svg>
  ),
  Website: (
    <svg aria-label="Website icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12c0 1.582.39 3.07 1.078 4.388l2.725-2.726A4 4 0 018 12H4zm6 6.93A8.001 8.001 0 014.07 14H8a4 4 0 014 4v4.93zM13.93 20A8.001 8.001 0 0020 13.93V16a4 4 0 01-4 4h-2.07zM20 12c0 1.582-.39 3.07-1.078 4.388l-2.725-2.726A4 4 0 0016 12h4zm-8-8c3.311 0 6 2.689 6 6h-4a2 2 0 00-2-2V4zm0 2a2 2 0 00-2 2H8c0-3.311 2.689-6 6-6v4z"/>
    </svg>
  )
};

const customTabTheme = {
  tabs: {
    tablist: {
      base: "flex overflow-x-auto justify-center scrollbar-hide space-x-0 lg:space-x-3",
      styles: {
        underline: "border-b border-gray-300"
      },
      tabitem: {
        base: `flex flex-col items-center justify-center p-2 md:p-3 text-xs md:text-sm font-medium min-w-[46px] md:min-w-[80px] hover:bg-white/30 rounded-lg transition-all ${textSecondary}`,
        styles: {
          underline: {
            base: "border-b-2",
            active: {
              on: `${textPrimary} border-gray-700`,
              off: "border-transparent hover:text-gray-700 hover:border-gray-300"
            }
          }
        }
      }
    }
  }
};

function WebPage() {
  const {
    profile,
    experiences,
    educations,
    portofolios,
    categories,
    certificates,
    publications,
    achievements,
    skills,
    cvData,
    fetchCV,
    loading,
    error
  } = useWebPageController();

  const [expandedExperiences, setExpandedExperiences] = useState({});
  const [expandedEducations, setExpandedEducations] = useState({});
  const [activePortfolioCategory, setActivePortfolioCategory] = useState(categories[0]?.id || null);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [showCVModal, setShowCVModal] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return 'Present';
    try {
      return format(new Date(dateString), 'MMM yyyy');
    } catch {
      return 'Invalid date';
    }
  };

  if (loading) return <div className={`text-center p-8 ${textPrimary}`}>Loading...</div>;
  if (error) return <div className="text-center p-8 text-red-500">Error: {error}</div>;

  return (
    <>
    {/* <Seo 
        title={`${profile?.fullname}'s Professional Portfolio`}
        description={`View ${profile?.fullname}'s digital portfolio created with Portoize. Explore professional achievements and work experience.`}
      /> */}
    <div className="min-h-screen relative bg-gradient-to-br from-sky-200 via-sky-50 to-sky-300 animate-gradient bg-[length:200%_200%]">
      <PortoModal
        isOpen={selectedPortfolio !== null}
        onClose={() => setSelectedPortfolio(null)}
        portfolio={selectedPortfolio}
        categories={categories}
        formatDate={formatDate}
      />
      <div className="fixed inset-0 bg-noise opacity-10 pointer-events-none z-0"></div>
      
      <div className="grid md:grid-cols-12 grid-cols-1 relative z-10">
        {/* Photo Side */}
        <div className='grid items-center p-6 lg:col-span-4 md:col-span-5'>
          <div>
            <div className={`grid sm:grid-cols-2 md:grid-cols-1 lg:p-8 p-6 w-full md:max-w-sm mx-auto mb-0 ${glassPanelDark}`}>
              <div className='md:pr-0 pr-3'>
                <img 
                  className="object-cover w-3/4 h-full mx-auto aspect-square rounded-xl border border-white/30 shadow-md" 
                  src={profile?.avatarUrl} 
                  alt="avatar"
                />
              </div>
              <div className="pt-6 md:pl-0 pl-3">
                <h1 className={`text-xl font-semibold ${textPrimaryLight}`}>{profile?.fullname}</h1>
                <p className={`py-2 ${textSecondaryLight}`}>{profile?.title_web}</p>

                {/* Location */}
                <div className={`flex items-center mt-4 ${textSecondaryLight}`}>
                  <svg aria-label="location pin icon" className="w-6 h-6 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M16.2721 10.2721C16.2721 12.4813 14.4813 14.2721 12.2721 14.2721C10.063 14.2721 8.27214 12.4813 8.27214 10.2721C8.27214 8.063 10.063 6.27214 12.2721 6.27214C14.4813 6.27214 16.2721 8.063 16.2721 10.2721ZM14.2721 10.2721C14.2721 11.3767 13.3767 12.2721 12.2721 12.2721C11.1676 12.2721 10.2721 11.3767 10.2721 10.2721C10.2721 9.16757 11.1676 8.27214 12.2721 8.27214C13.3767 8.27214 14.2721 9.16757 14.2721 10.2721Z"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.79417 16.5183C2.19424 13.0909 2.05438 7.3941 5.48178 3.79418C8.90918 0.194258 14.6059 0.0543983 18.2059 3.48179C21.8058 6.90919 21.9457 12.606 18.5183 16.2059L12.3124 22.7241L5.79417 16.5183ZM17.0698 14.8268L12.243 19.8965L7.17324 15.0698C4.3733 12.404 4.26452 7.9732 6.93028 5.17326C9.59603 2.37332 14.0268 2.26454 16.8268 4.93029C19.6267 7.59604 19.7355 12.0269 17.0698 14.8268Z"/>
                  </svg>
                  <h1 className="px-2 text-sm">
                    {`${profile?.city}, ${profile?.country}`}
                  </h1>
                </div>

                {/* Social Media */}
                <div className={`grid lg:grid-cols-2 grid-cols-1 space-y-2 mt-6 ${textSecondaryLight}`}>
                  {[
                    { platform: 'Email', url: profile?.email },
                    { platform: 'LinkedIn', url: profile?.linkedin },
                    { platform: 'GitHub', url: profile?.github },
                    { platform: 'Behance', url: profile?.behance },
                    { platform: 'Instagram', url: profile?.instagram },
                    { platform: 'Website', url: profile?.personal_web }
                  ].map((social, i) => (
                    social.url && social.platform == 'Email' ? (
                      <p key={i} className="flex items-center transition-colors lg:col-span-2">
                        <span className="w-6 h-6 rounded-lg flex items-center justify-center">
                          {socialIcons[social.platform]}
                        </span>
                        <span className="px-2 text-sm">{social.url}</span>
                      </p>
                    ) : social.url && (
                      <a key={i} href={social.url} target="_blank" rel="noopener noreferrer" className="flex items-center transition-colors">
                        <span className="w-6 h-6 rounded-lg flex items-center justify-center">
                          {socialIcons[social.platform]}
                        </span>
                        <span className="px-2 text-sm">{social.platform}</span>
                      </a>
                    )))}
                </div>
              </div>
            </div>
            {/* Tombol View CV */}
            <button 
              onClick={async () => {
                if (profile?.selected_cv_id) {
                  await fetchCV(profile.user_id, profile.selected_cv_id);
                  setShowCVModal(true);
                }
              }}
              className="flex items-center justify-center my-4 lg:px-8 px-6 py-2 w-full md:max-w-sm mx-auto bg-white/20 border-gray-700 border-2 hover:bg-white/30 rounded-lg transition-colors shadow-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="text-sm font-bold">VIEW CV</span>
            </button>
          </div>
        </div>

        {/* Main Side */}
        <div className='md:pb-0 pb-10 lg:col-span-8 md:col-span-7 grid items-center md:h-screen'>
          <div className={`mx-3 md:mr-5 md:mx-0 ${glassPanel}`}>
            <Flowbite theme={{ theme: customTabTheme }}>
              <Tabs aria-label="Tabs with icons" variant="underline" className='!p-1'>
                {/* Profile Tab */}
                <Tabs.Item title={
                  <>
                    <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    <span className="hidden md:inline">Profile</span>
                  </>
                }>
                  <div className="container xl:p-7 p-3 md:max-h-[32rem] lg:max-h-[40rem] mx-auto md:overflow-auto">
                    <div className="items-center lg:flex">
                      <div className="w-full">
                        <h1 className={`text-3xl font-semibold ${textPrimary} lg:text-4xl`}>
                          {`Hi, I am ${profile?.shortname}`}
                        </h1>
                        <p className={`mt-3 ${textSecondary} md:text-md text-sm leading-relaxed`}>{profile?.bio_web}</p>
                      </div>
                      {/* <div className="xl:flex hidden items-center justify-center w-full mt-6 lg:mt-0 lg:w-1/2">
                        <img className="w-full h-full lg:max-w-3xl hover:scale-105 transition-transform duration-300" src="/browsing.svg" alt="Catalogue-pana.svg"/>
                      </div> */}
                    </div>
                    
                    {/* Skills Section */}
                    <div className="container py-10 mx-auto">
                      <h1 className={`text-3xl font-semibold ${textPrimary} lg:text-4xl mb-8`}>What I Do?</h1>
                      <div className="grid grid-cols-1 gap-5 mt-3 xl:mt-7 md:grid-cols-2 xl:grid-cols-2">
                        {skills.map((skill, i) => (
                          <div 
                            key={i} 
                            className={`md:p-6 p-4 ${glassCard}`}
                          >
                            <div className="flex items-center gap-3 mb-3">
                              <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                                <svg className="w-5 h-5 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                </svg>
                              </div>
                              <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>{skill.name}</h3>
                            </div>
                            <p className={`mt-2 ${textSecondary}`}>{skill.description}</p>
                            {skill.sub_skill && (
                              <div className="mt-3 flex flex-wrap gap-2">
                                {skill.sub_skill.split(';').map((sub, idx) => (
                                  <span 
                                    key={idx}
                                    className="px-3 py-1 bg-gray-600 text-white font-bold text-xs rounded-full whitespace-nowrap transition-colors duration-200"
                                  >
                                    {sub.trim()}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Tabs.Item>

                {/* Experience Tab */}
                {experiences.length > 0 && (
                  <Tabs.Item title={
                    <>
                      <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                      </svg>
                      <span className="hidden md:inline">Experience</span>
                    </>
                  }>
                    <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                      <h1 className={`text-2xl font-semibold ${textPrimary} lg:text-3xl mb-8 relative`}>
                        Professional Journey
                      </h1>
                      <div className="relative md:pl-8 pl-3 border-l-4 border-gray-600 space-y-8">
                        {experiences.map((exp, i) => (
                          <div 
                            key={i} 
                            className="relative md:pl-8 pl-3 group"
                          >
                            <div className="absolute left-[-13px] top-5 w-6 h-6 bg-gray-600 border-4 border-gray-300 rounded-full"></div>
                            <div className={`md:p-6 p-4 ${glassCard}`}>
                              <div className="flex justify-between items-start mb-2">
                                <div>
                                  <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                    {exp.position} ({exp.type})
                                  </h3>
                                  <p className={`${textSecondary} md:text-md text-sm font-medium`}>
                                    {exp.company} - {exp.city}, {exp.country}
                                  </p>
                                </div>
                                <span className={`px-3 py-1 bg-white/20 ${textSecondary} md:text-sm text-xs rounded-full`}>
                                  {formatDate(exp.start)} - {formatDate(exp.end)}
                                </span>
                              </div>
                              
                              {(exp.description || exp.achievements || exp.certificate) && (
                                <div className="mt-4 space-y-2">
                                  <button 
                                    onClick={() => setExpandedExperiences(prev => ({
                                      ...prev, 
                                      [exp.id]: !prev[exp.id]
                                    }))}
                                    className={`text-sm ${textAccent} font-medium`}
                                  >
                                    {expandedExperiences[exp.id] ? 'Hide Details' : 'See Details'}
                                  </button>
                                  
                                  {expandedExperiences[exp.id] && (
                                    <div className={`${textSecondary} space-y-4`}>
                                      {/* Description - Tampil jika ada */}
                                      {exp.description && (
                                        <div>
                                          <h4 className="font-medium mb-1">Job Description</h4>
                                          <p>{exp.description}</p>
                                        </div>
                                      )}

                                      {/* Achievements - Tampil jika ada */}
                                      {exp.achievements && (
                                        <div>
                                          <h4 className="font-medium mb-1">Key Achievements</h4>
                                          <ul className="list-disc pl-5">
                                            {exp.achievements.split(';').map((ach, idx) => (
                                              <li key={idx}>{ach.trim()}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      )}

                                      {/* Certificate - Tampil jika ada */}
                                      {exp.certificate && (
                                        <div>
                                          <h4 className="font-medium mb-1">Related Certification</h4>
                                          <a
                                            href={exp.certificate}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-block text-sm text-blue-600 hover:underline"
                                          >
                                            View Certificate
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}

                              {exp.images?.length > 0 && (
                                <div className="mt-4">
                                  <Carousel
                                    indicators={true}
                                    leftControl={<span className={textPrimary}>❮</span>}
                                    rightControl={<span className={textPrimary}>❯</span>}
                                    className="rounded-lg overflow-hidden"
                                  >
                                    {exp.images.map((img, idx) => (
                                      <div key={idx} className="relative h-64">
                                        <img 
                                          src={img.publicUrl}
                                          alt={`Experience ${idx + 1}`}
                                          className="h-full w-full object-cover"
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                          }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                                      </div>
                                    ))}
                                  </Carousel>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Tabs.Item>
                )}

                {/* Education Tab */}
                {educations.length > 0 && (
                  <Tabs.Item title={
                    <>
                      <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M12 14l9-5-9-5-9 5 9 5z"/>
                        <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"/>
                      </svg>
                      <span className="hidden md:inline">Education</span>
                    </>
                  }>
                    <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                      <h1 className={`text-2xl font-semibold ${textPrimary} lg:text-3xl mb-8 relative`}>
                        Academic Path
                      </h1>
                      <div className="relative md:pl-8 pl-3 border-l-4 border-gray-600 space-y-8">
                        {educations.map((edu, i) => (
                          <div 
                            key={i} 
                            className="relative md:pl-8 pl-3 group"
                          >
                            <div className="absolute left-[-13px] top-5 w-6 h-6 bg-gray-600 border-4 border-gray-300 rounded-full"></div>
                            <div className={`md:p-6 p-4 ${glassCard}`}>
                              <div className="flex justify-between items-start mb-2">
                                <div>
                                  <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                    {edu.institution} ({edu.type})
                                  </h3>
                                  <p className={`${textSecondary} md:text-md text-sm font-medium`}>
                                    {edu.degree} {edu.field && `in ${edu.field}`} {edu.gpa && `• GPA: ${edu.gpa}`}
                                  </p>
                                </div>
                                <span className={`px-3 py-1 bg-white/20 ${textSecondary} md:text-sm text-xs rounded-full`}>
                                  {formatDate(edu.start)} - {formatDate(edu.end)}
                                </span>
                              </div>

                              {edu.achievements && (
                                <div className="mt-4 space-y-2">
                                  <button 
                                    onClick={() => setExpandedEducations(prev => ({
                                      ...prev, 
                                      [edu.id]: !prev[edu.id]
                                    }))}
                                    className={`text-sm ${textAccent} font-medium`}
                                  >
                                    {expandedEducations[edu.id] ? 'Hide Achievements' : 'Show Achievements'}
                                  </button>
                                  {expandedEducations[edu.id] && (
                                    <ul className="list-disc pl-5 text-gray-600">
                                      {edu.achievements.split(';').map((ach, idx) => (
                                        <li key={idx}>{ach.trim()}</li>
                                      ))}
                                    </ul>
                                  )}
                                </div>
                              )}
                              {edu.images?.length > 0 && (
                                <div className="mt-4">
                                  <Carousel
                                    indicators={true}
                                    leftControl={<span className={textPrimary}>❮</span>}
                                    rightControl={<span className={textPrimary}>❯</span>}
                                    className="rounded-lg overflow-hidden"
                                  >
                                    {edu.images.map((img, idx) => (
                                      <div key={idx} className="relative h-64">
                                        <img
                                          src={img.publicUrl}
                                          alt={`Education ${idx + 1}`}
                                          className="h-full w-full object-cover"
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                          }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                                      </div>
                                    ))}
                                  </Carousel>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Tabs.Item>
                )}

                {/* Portfolio Tab */}
                {portofolios.length > 0 && (
                  <Tabs.Item title={
                    <>
                      <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/>
                      </svg>
                      <span className="hidden md:inline">Project</span>
                    </>
                  }>
                    <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                      <div className="container mx-auto">
                        <h1 className={`text-2xl font-semibold text-center ${textPrimary} lg:text-3xl mb-2`}>
                          Project Showcase
                        </h1>
                        <Flowbite theme={{ theme: customTabTheme }}>
                          <Tabs 
                            aria-label="Portfolio categories" 
                            variant='underline' 
                            className='!justify-center mt-1 !border-none !p-0'
                            onActiveTabChange={(tab) => setActivePortfolioCategory(categories[tab]?.id)}
                          >
                            {categories.map((category, i) => (
                              <Tabs.Item key={i} title={category.name}>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 p-4">
                                  {portofolios
                                    .filter(p => p.category_id === category.id)
                                    .map((porto, idx) => (
                                      <div 
                                        key={idx} 
                                        className={`${glassCard} group overflow-hidden`}
                                      >
                                        {porto.images?.length > 0 && (
                                          <Carousel
                                            indicators={true}
                                            className="h-48 rounded-t-xl relative"
                                          >
                                            {porto.images.map((img, imgIdx) => (
                                              <div key={imgIdx} className="relative h-48">
                                                <img
                                                  src={img.publicUrl}
                                                  alt={`Portfolio ${imgIdx + 1}`}
                                                  className="h-full w-full object-cover"
                                                  onError={(e) => {
                                                    e.target.style.display = 'none';
                                                  }}
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                                              </div>
                                            ))}
                                          </Carousel>
                                        )}
                                        <div className="p-4">
                                          <div className="w-full">
                                            <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                              {porto.title}
                                            </h3>
                                          </div>
                                          <p className={`${textSecondary} mt-2 line-clamp-3`}>
                                            {porto.description}
                                          </p>
                                          <div className="flex items-center gap-2 mt-3">
                                            <button onClick={() => setSelectedPortfolio(porto)} className={`${textPrimary} bg-teal-600 hover:bg-teal-700 shadow-lg px-3 py-2 rounded-full text-gray-50 font-bold text-sm flex items-center gap-2`}>
                                              View Details
                                            </button>
                                            {porto.url && (
                                              <a 
                                                href={porto.url} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="text-sm text-gray-50 font-bold text-center bg-sky-600 py-2 px-3 rounded-full hover:bg-sky-700 shadow-lg"
                                              >
                                                View Project
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </Tabs.Item>
                            ))}
                          </Tabs>
                        </Flowbite>
                      </div>
                    </div>
                  </Tabs.Item>
                )}
                
                {/* Certificate Tab */}
                {certificates.length > 0 && (
                  <Tabs.Item title={
                      <>
                        <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                        </svg>
                        <span className="hidden md:inline">Achievement</span>
                      </>
                    }>
                    <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                      <h1 className={`text-2xl font-semibold ${textPrimary} lg:text-3xl mb-8 flex items-center gap-3`}>
                        <svg className="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                        Achievements & Awards
                      </h1>
                      <div className="grid grid-cols-1 gap-5">
                        {achievements.map((achievement, i) => (
                          <div 
                            key={i} 
                            className={`md:p-6 p-4 ${glassCard}`}
                          >
                            <div className="flex items-start gap-4">
                              <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                                <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                                </svg>
                              </div>
                              <div className="flex-grow">
                                <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                  {achievement.name}
                                </h3>
                                <div className="mt-2 flex flex-wrap gap-2">
                                  <span className={`px-2 py-1 bg-gray-600/20 ${textSecondary} text-xs rounded-full`}>
                                    {achievement.organizer}
                                  </span>
                                  {achievement.level && (
                                    <span className={`px-2 py-1 bg-blue-600/20 text-blue-600 text-xs rounded-full`}>
                                      {achievement.level}
                                    </span>
                                  )}
                                  <span className={`px-2 py-1 bg-gray-600/20 ${textSecondary} text-xs rounded-full`}>
                                    {formatDate(achievement.date)}
                                  </span>
                                </div>
                                {achievement.description && (
                                  <p className={`mt-3 ${textSecondary}`}>{achievement.description}</p>
                                )}
                                {achievement.certificate_link && (
                                  <a
                                    href={achievement.certificate_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-3 inline-block text-sm text-blue-600 hover:underline"
                                  >
                                    View Certificate
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        {achievements.length === 0 && (
                          <div className={`text-center py-8 ${textSecondary}`}>
                            No achievements to display
                          </div>
                        )}
                      </div>
                    </div>
                  </Tabs.Item>
                )}
                
                {/* Certificate Tab */}
                {certificates.length > 0 && (
                <Tabs.Item title={
                  <>
                    <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
                    </svg>
                    <span className="hidden md:inline">Certificate</span>
                  </>
                }>
                  <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                    <h1 className={`text-2xl font-semibold ${textPrimary} lg:text-3xl mb-8 flex items-center gap-3`}>
                      <svg className="w-8 h-8 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-3.138 3.138 3.066 3.066 0 00-1.946.806 3.066 3.066 0 01-4.438 0 3.066 3.066 0 00-1.946-.806 3.066 3.066 0 01-3.138-3.138 3.066 3.066 0 00-.806-1.946 3.066 3.066 0 010-4.438 3.066 3.066 0 00.806-1.946 3.066 3.066 0 013.138-3.138z" clipRule="evenodd"/>
                      </svg>
                      Certifications
                    </h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      {certificates.map((cert, i) => (
                        <div 
                          key={i} 
                          className={`md:p-6 p-4 ${glassCard}`}
                        >
                          <div className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                              <svg className="w-6 h-6 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                              </svg>
                            </div>
                            <div>
                              <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                {cert.title} {cert.cred_id && `(${cert.cred_id})`}
                              </h3>
                              <p className={`${textSecondary} mt-1`}>{cert.org}</p>
                              <div className="mt-3 flex items-center gap-2 text-sm text-gray-500">
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"/>
                                </svg>
                                {formatDate(cert.issue)} - {formatDate(cert.expire)}
                              </div>
                              {cert.cred_url && (
                                <a
                                  href={cert.cred_url}
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="mt-2 inline-block text-sm text-blue-600 hover:underline"
                                >
                                  Verify Credential
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Tabs.Item>
                )}

                {/* Publication Tab */}
                {publications.length > 0 && (
                  <Tabs.Item title={
                    <>
                      <svg className="w-5 h-5 md:mb-1 mx-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/>
                      </svg>
                      <span className="hidden md:inline">Publication</span>
                    </>
                  }>
                    <div className="container md:max-h-[32rem] lg:max-h-[40rem] mx-auto p-4 overflow-auto">
                      <h1 className={`text-2xl font-semibold ${textPrimary} lg:text-3xl mb-8 flex items-center gap-3`}>
                        <svg className="w-8 h-8 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 005.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"/>
                        </svg>
                        Research & Publications
                      </h1>
                      <div className="grid grid-cols-1 gap-5">
                        {publications.map((pub, i) => (
                          <div 
                            key={i} 
                            className={`md:p-6 p-4 ${glassCard}`}
                          >
                            <div className="flex items-start gap-4">
                              <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                                <svg className="w-6 h-6 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd"/>
                                </svg>
                              </div>
                              <div>
                                <h3 className={`md:text-xl text-md font-semibold ${textPrimary}`}>
                                  {pub.title} ({pub.type})
                                </h3>
                                <p className={`${textSecondary} mt-1`}>{pub.publisher}</p>
                                <div className="mt-3 flex items-center gap-2 text-sm text-gray-500">
                                  <div className="flex items-center gap-2">
                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"/>
                                    </svg>
                                    {formatDate(pub.date)}
                                  </div>
                                </div>
                                <p className={`mt-3 ${textSecondary}`}>{pub.description}</p>
                                {pub.url && (
                                  <a
                                    href={pub.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-2 inline-block text-sm text-blue-600 hover:underline"
                                  >
                                    View Publication
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Tabs.Item>
                )}
              </Tabs>
            </Flowbite>
          </div>
        </div>
      </div>
      {/* CV Modal */}
      {showCVModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col">
            <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
              <h2 className="text-xl font-semibold">{profile?.fullname}'s CV</h2>
              <button 
                onClick={() => setShowCVModal(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>
            {cvData ? (
              <div className="p-2 flex-1 container overflow-hidden justify-center items-center">
                <PDFViewerCustom cvData={{
                  profileData: {
                    ...cvData.cv_data.profile,
                    socialLinks: {
                      email: profile.email,
                      github: profile.github,
                      linkedin: profile.linkedin,
                      behance: profile.behance,
                      instagram: profile.instagram,
                      youtube: profile.youtube,
                      personal_web: profile.personal_web,
                      phone: profile.phone
                    },
                    fullname: profile.fullname,
                  },
                  experienceData: cvData.cv_data.experiences,
                  educationData: cvData.cv_data.educations,
                  certificateData: cvData.cv_data.certificates,
                  publicationData: cvData.cv_data.publications,
                  skillData: cvData.cv_data.skills,
                  achievementData: cvData.cv_data.achievements,
                  portfolioData: cvData.cv_data.portfolios,
                }} />
              </div>
            ) : (
              <div className="text-center p-8">
                <p className="text-red-500">CV Not Found</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default WebPage;